import Vue from 'vue';
import moment from 'moment';
import $functions from './functions';

Vue.filter('formatDate', (date, formato) => {
  if (!date) return '-';
  return moment(String(date)).format(formato);
});

Vue.filter('formatSmartDate', date => {
  if (!date) return '-';
  const novaData = moment(date, 'YYYY/MM/DD HH:mm:ss').fromNow();
  return novaData.charAt(0).toUpperCase() + novaData.slice(1);
});

Vue.filter('idade', nascimento => {
  if (!nascimento) return '-';
  const data_atual = moment();
  let data_nascimento;

  if (nascimento.indexOf('-') === -1)
    data_nascimento = moment.duration(data_atual.diff(moment(nascimento, 'DD/MM/YYYY')));
  else
    data_nascimento = moment.duration(data_atual.diff(moment(nascimento, 'YYYY-MM-DD')));

  if (data_nascimento.years() < 2)
    if (data_nascimento.years() < 1) {
      if (data_nascimento.months() === 1)
        return `${data_nascimento.months()} mês e ${data_nascimento.days()} dia(s)`;
      return `${data_nascimento.months()} meses e ${data_nascimento.days()} dia(s)`;
    } else {
      if (data_nascimento.months() === 1)
        return '1 ano e 1 mês';
      return `1 ano e ${data_nascimento.months()} meses`;
    } return `${data_nascimento.years()} anos`;
});

Vue.filter('cpf_cnpj', $functions.maskCpfCnpj);

Vue.filter('numero_pis', $functions.maskNumeroPis);

Vue.filter('telefone', $functions.maskTelefone);

Vue.filter('dinheiro', $functions.maskDinheiro);

Vue.filter('exibeLista', (lista, campo) => lista.map(item => item[campo]).join(', '));

Vue.filter('sexo', sexo => (sexo ? 'F' : 'M'));

Vue.filter('sexoAbreviacao', sexo => {
  if (sexo !== null)
    return sexo === 0 ? 'Masc.' : 'Fem.';
  return '-';
});

Vue.filter('sexoCompleto', sexo => (sexo ? 'feminino' : 'masculino'));

Vue.filter('nomeLetra', nome_completo => {
  const arrayNome = nome_completo.split(' ');
  const primeiraLetra = arrayNome[0].substring(0, 1).toUpperCase();

  return `${primeiraLetra}`;
});

Vue.filter('conselho', $functions.formatConselho);
